import styled, { css } from "styled-components";
import { ControlLabel as BootstrapControlLabel } from "react-bootstrap";
const ControlLabel = styled(BootstrapControlLabel)(
  ({ theme }) => css`
    color: ${theme.colors.text.primary};
    font-weight: bold;
    margin-bottom: 5px;
    display: inline-block;
  `
);
export default ControlLabel;
